import createApi from './api';

export const ResourceType = {
  agencies: {
    name: 'agencies',
    idField: 'agency_id',
    basePath: '/agencies',
  },
  cameras: {
    name: 'cameras',
    idField: 'camera_id',
    basePath: '/cameras',
  },
  customers: {
    name: 'customers',
    idField: 'customer_id',
    basePath: '/customers',
  },
  containers: {
    name: 'containers',
    idField: 'container_id',
    basePath: '/containers',
  },
  containerClasses: {
    name: 'containerContentClasses',
    idField: 'content_class',
    basePath: '/containers/classes',
  },
  devices: {
    name: 'devices',
    idField: 'device_id',
    basePath: '/devices',
  },
  doors: {
    name: 'doors',
    idField: 'door_id',
    basePath: '/doors',
  },
  btc: {
    name: 'btc',
    idField: 'id',
    basePath: '/btc',
  },
  employees: {
    name: 'employees',
    idField: 'employee_id',
    basePath: '/employees',
  },
  locations: {
    name: 'locations',
    idField: 'location_id',
    basePath: '/locations',
  },
  users: {
    name: 'users',
    idField: 'user_id',
    basePath: '/accounts',
  },
  featureFlags: {
    name: 'featureFlags',
    idField: 'id',
    basePath: '/config'
  }
};

export default class ResourceService {
  constructor(resource) {
    this.resource = resource;
    this.api = createApi({
      baseUrl: `admin${this.resource.basePath}`,
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  async loadAll() {
    return this.api.get('list');
  }

  async load(id) {
    const { idField } = this.resource;
    return this.api.get(`get?${idField}=${id}`);
  }

  async create(data) {
    return this.api.post('create', data);
  }

  async update(data) {
    return this.api.post('update', data);
  }

  async delete(id) {
    const { idField } = this.resource;
    return this.api.post('delete', {
      [idField]: id,
    });
  }
}